import { QTablePagination } from 'src/types';
import { QTabsProps } from 'quasar';
import { getCurrentEdition } from './editions';

const defaultPageSize = 50;

export default {
  dateFormat: 'D MMM YYYY',
  dateTimeFormat: 'D MMM YYYY HH:mm',
  minDate: '2000-01-01', // earliest date on a date validator for new assessments
  dateRequiredMessage: 'Enter a date as YYYY-MM-DD',
  valueRequiredMessage: 'Value is required',
  valueRequiredYesMessage: 'Choose "Yes" or clear "Date allowed to return"',
  valueOutOfRange: 'Enter a sensible value',
  nameRequiredMessage: 'Name is required',
  emailRequiredMessage: 'Email address is required',
  bloodPressureRequiredMessage: 'Expected blood pressure eg 120/80',
  phoneRequiredMessage:
    'Phone number with international country code is required (eg +64 12 345 6789)',
  passwordRequiredMessage: 'Enter your password',
  passwordMinLength: 8, // characters
  passwordNotValidMessage:
    'At least 8 characters (at least one upper case, one lower, one digit, and one special character)',
  passwordMatchMessage: 'Passwords must match',

  changesSavedMessage: 'Changes saved OK',

  // for q-tables everywhere: a standard set of defaults so they all look similar
  qTableDefaults: {
    'title-class': 'text-weight-light text-h3',
    'row-key': 'id',
    'rows-per-page-options': [10, 20, defaultPageSize, 100],
    flat: true,
    'wrap-cells': true,
    'no-results-label': 'Nothing matches your search',
    'no-data-label': 'No records. You can add one (if you have permission)',
    'loading-label': 'Loading data...',
  },

  // for the home page dashboard
  qTableDefaultsHome: {
    'title-class': 'text-h4',
    'row-key': 'id',
    'hide-pagination': true,
    flat: true,
    'rows-per-page-options': [10],
  },

  defaultPageSize,

  qTablePagination: {
    sortBy: undefined,
    descending: undefined,
    page: 1,
    rowsPerPage: defaultPageSize,
    rowsNumber: 0,
  } as QTablePagination,

  qTabDefaults: {
    class: 'text-grey',
    'active-color': 'primary',
    'indicator-color': 'primary',
    align: 'left',
    'narrow-indicator': true,
  } as QTabsProps,

  iccReviewDaysUntilOverdue: 2,
  iccReviewDaysUntilLocked: 5, // can edit after completion until locked

  // on 12 Sep, Ed requested 15 days because people are slow to finish, and we are adding stuff still so they need to go back and tidy up
  comprehensiveHoursUntilLocked: 90 * 24, // can edit after completion until locked

  placeholderImage: getCurrentEdition().branding.placeholderPath, // for teams, unions, tournaments
  playerDefaultImage: getCurrentEdition().branding.playerDefaultPath, // whe there is no player image or team player default image
};
